export default "<p>owner-medical-consultation-cirugy-table works!</p>\n"